import {
  GenerationType,
  marketingAgentPromptScenarioSchema,
} from "@redotech/redo-model/marketing/marketing-agent-prompt/marketing-agent-prompt-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const updateScenarioInputSchema_ = z.object({
  scenarioId: zExt.objectId(),
  smsTemplateId: zExt.objectId().optional(),
  generationType: z.enum([GenerationType.MANUAL, GenerationType.AI]).optional(),
  displayLabel: z.string().optional(),
  displayDescription: z.string().optional(),
  prompt: z.string().optional(),
});
export interface UpdateScenarioInput
  extends z.infer<typeof updateScenarioInputSchema_> {}
export const updateScenarioInputSchema: z.ZodType<UpdateScenarioInput> =
  updateScenarioInputSchema_;

export const updateScenario = {
  name: "updateScenario" as const,
  input: updateScenarioInputSchema,
  output: marketingAgentPromptScenarioSchema,
};
